import { render, staticRenderFns } from "./ReportStats.vue?vue&type=template&id=2f1017ae&scoped=true&"
import script from "./ReportStats.vue?vue&type=script&lang=js&"
export * from "./ReportStats.vue?vue&type=script&lang=js&"
import style0 from "./ReportStats.vue?vue&type=style&index=0&id=2f1017ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1017ae",
  null
  
)

export default component.exports